module.exports = __webpack_public_path__ + "img/Logo_Mitta.aaaf9d66.png";